import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-end pb-16 md:pb-24 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20composition%20of%20fashion%20accessories%20and%20lifestyle%20items%20on%20a%20warm%20terracotta%20tinted%20textured%20paper%20surface%2C%20featuring%20a%20minimalist%20leather%20watch%2C%20gold%20rimmed%20sunglasses%2C%20a%20linen%20scarf%20draped%20elegantly%2C%20ceramic%20vase%20with%20dried%20pampas%20grass%2C%20soft%20warm%20golden%20hour%20light%20streaming%20from%20upper%20left%20corner%2C%20delicate%20shadows%2C%20Mediterranean%20aesthetic%2C%20rich%20earthy%20tones%20of%20rust%20ochre%20sand%20and%20cream%2C%20editorial%20fashion%20catalog%20photography%2C%20no%20text%20overlay%2C%20sophisticated%20composition%20with%20negative%20space&width=1920&height=1080&seq=kakobuy-hero-v3-2026&orientation=landscape"
          alt="Kakobuy Spreadsheet produkty i akcesoria"
          title="Kakobuy Spreadsheet – produkty i akcesoria"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl">
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-[1.05] mb-4">
              <span className="block">{t("hero.title1")}</span>
              <span className="block text-accent-300">{t("hero.title2")}</span>
            </h1>
            <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-lg">
              {t("hero.subtitle")}
            </p>
            <div className="flex flex-col sm:flex-row items-start gap-3">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-sm transition-all cursor-pointer whitespace-nowrap bg-accent-500 text-background-50 hover:bg-accent-600"
              >
                {t("hero.cta")}
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <Link
                to="/artykul/jak-korzystac-z-kakobuy-spreadsheet"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-medium text-sm transition-all cursor-pointer whitespace-nowrap border border-background-50/30 text-background-50 hover:bg-background-50/15"
              >
                {t("hero.ctaArticle")}
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}